// src/utils/reporteRecepcionEquipoGenerator.js

// 👈 NUEVO: Importar función que obtiene los datos de la empresa actual
import { obtenerDatosEmpresa } from './tenantConfig';

// Configuración por defecto (fallback)
const SYSTEM_JJ_CONFIG = {
  nombre: "SYSTEM JJ",
  rif: "J-41023119-0",
  direccion: "C.C. LATIN CENTER PB LOCAL 01",
  telefono: "0416-7594723",
  whatsapp: "04167594723",
  ciudad: "ACARIGUA - PORTUGUESA",
  email: "soporte@systemjj.com",
  sitioWeb: "www.systemjj.com",
  slogan: "Servicio Técnico Especializado",
  lema: "Tecnología al servicio de la gente"
};

/**
 * 👈 NUEVO: Obtiene la config de la empresa actual con fallback
 */
const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa();
    return {
      nombre: datos.nombreComercial || datos.nombre || SYSTEM_JJ_CONFIG.nombre,
      rif: datos.rif || SYSTEM_JJ_CONFIG.rif,
      direccion: datos.direccion || SYSTEM_JJ_CONFIG.direccion,
      telefono: datos.telefono1 || datos.telefono2 || SYSTEM_JJ_CONFIG.telefono,
      whatsapp: datos.whatsapp || datos.telefono1 || SYSTEM_JJ_CONFIG.whatsapp,
      ciudad: datos.ciudad || SYSTEM_JJ_CONFIG.ciudad,
      email: datos.email || SYSTEM_JJ_CONFIG.email,
      sitioWeb: datos.sitioWeb || SYSTEM_JJ_CONFIG.sitioWeb,
      slogan: datos.slogan || SYSTEM_JJ_CONFIG.slogan,
      lema: datos.slogan || SYSTEM_JJ_CONFIG.lema,
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    console.warn('⚠️ No se pudo obtener config del tenant, usando fallback:', err);
    return { ...SYSTEM_JJ_CONFIG, logoBase64: null };
  }
};

// Variable para el logo en base64
let LOGO_BASE64 = '';

/**
 * 👈 MODIFICADO: Prioriza el logo del tenant; si no hay, usa /jj.png
 */
export const cargarLogo = async () => {
  try {
    const empresa = getEmpresa();
    if (empresa.logoBase64) {
      const base64Limpio = empresa.logoBase64.includes(',')
        ? empresa.logoBase64.split(',')[1]
        : empresa.logoBase64;
      LOGO_BASE64 = base64Limpio;
      console.log('✅ Logo del tenant cargado (recepción)');
      return LOGO_BASE64;
    }

    const response = await fetch('/jj.png');
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        LOGO_BASE64 = reader.result.split(',')[1];
        resolve(LOGO_BASE64);
      };
      reader.onerror = () => {
        LOGO_BASE64 = '';
        resolve('');
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error cargando el logo:', error);
    LOGO_BASE64 = '';
    return '';
  }
};

export const getLogoBase64 = () => LOGO_BASE64;

// ==================== UTILIDADES ====================

export const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return fechaISO;
  }
};

export const formatearFechaCorta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return fechaISO;
  }
};

export const formatearNumero = (numero, decimales = 2) => {
  if (numero === null || numero === undefined) return '0.00';
  return new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  }).format(numero);
};

export const formatearMonedaUSD = (monto) => {
  if (monto === null || monto === undefined) return '$0.00';
  return `$${formatearNumero(monto, 2)}`;
};

// ==================== NORMALIZACIÓN ====================

export const normalizarRecepcion = (item) => {
  if (!item) return null;

  return {
    idRecepcionEquipo: item.idRecepcionEquipo,
    numeroOrden: item.numeroOrden || `ORD-${item.idRecepcionEquipo || '000'}`,
    fechaIngreso: item.fechaIngreso,
    fechaEntrega: item.fechaEntrega,
    fechaPago: item.fechaPago,
    nombreCliente: item.nombreCliente || 'Cliente Desconocido',
    idCliente: item.idCliente,
    descripcion: item.descripcion || 'Sin descripción',
    problema: item.problema || 'No especificado',
    nombreTecnico: item.nombreTecnico || 'NO ASIGNADO',
    nombreTecnicoRecepcion: item.nombreTecnicoRecepcion || item.nombreUsuario || '---',
    nombreTecnicoReparador: item.nombreTecnicoReparador || '---',
    nombreTecnicoEntrega: item.nombreTecnicoEntrega || '---',
    nombreEstado: item.nombreEstado || 'RECIBIDO',
    actividadesRealizadas: item.actividadesRealizadas || '',
    montoServiciosUsd: item.montoServiciosUsd || 0,
    montoProductosUsd: item.montoProductosUsd || 0,
    montoRepuestosUsd: item.montoRepuestosUsd || 0,
    precioTotalUsd: item.precioTotalUsd || 0,
    montoCobradoUsd: (item.montoCobradoUsd !== undefined && item.montoCobradoUsd !== null) ? item.montoCobradoUsd : (item.montoPagadoUsd || 0),
    montoPagadoUsd: item.montoPagadoUsd || item.montoCobradoUsd || 0,
    descuento: item.descuento || 0,
    metodoPago: item.metodoPagoDisplay || item.metodoPago || 'EFECTIVO',
    referenciaPago: item.referenciaPago || '---',
    tipoDiagnostico: item.tipoDiagnostico || item.TipoDiagnostico || '',
    montoPagadoDiagnosticoUsd: (item.montoPagadoDiagnosticoUsd !== undefined && item.montoPagadoDiagnosticoUsd !== null && item.montoPagadoDiagnosticoUsd > 0)
      ? item.montoPagadoDiagnosticoUsd
      : ((item.tipoDiagnostico || item.TipoDiagnostico || '').toString().toUpperCase().includes('EXPRE') ? 10 : 0),
    montoPagadoReparacionUsd: item.montoPagadoReparacionUsd || 0
  };
};

export const normalizarRecepciones = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map(item => normalizarRecepcion(item));
};

export const getEstadoStyle = (estado) => {
  const e = estado?.toLowerCase() || '';
  if (e.includes('diagno')) return 'background: #fef3c7; color: #92400e;';
  if (e.includes('reparado')) return 'background: #dcfce7; color: #166534;';
  if (e.includes('entrega')) return 'background: #dbeafe; color: #1e40af;';
  if (e.includes('espera')) return 'background: #f3e8ff; color: #6b21a8;';
  return 'background: #f3f4f6; color: #374151;';
};

// ==================== CÁLCULOS ====================

export const calcularEstadisticasRecepcion = (recepciones) => {
  const items = normalizarRecepciones(recepciones);
  const total = items.length;

  const estados = {};
  items.forEach(item => {
    const estado = item.nombreEstado || 'RECIBIDO';
    estados[estado] = (estados[estado] || 0) + 1;
  });

  const reparados = items.filter(r => r.nombreEstado?.toLowerCase().includes('reparado')).length;
  const entregados = items.filter(r => r.nombreEstado?.toLowerCase().includes('entrega')).length;
  const pendientes = total - entregados;

  const totalServicios = items.reduce((acc, r) => acc + (r.montoServiciosUsd || 0), 0);
  const totalProductos = items.reduce((acc, r) => acc + (r.montoProductosUsd || 0), 0);
  const totalRepuestos = items.reduce((acc, r) => acc + (r.montoRepuestosUsd || 0), 0);
  const totalDiagnosticos = items.reduce((acc, r) => acc + (r.montoPagadoDiagnosticoUsd || 0), 0);
  const totalGeneral = items.reduce((acc, r) => acc + (r.precioTotalUsd || 0) + (r.montoPagadoDiagnosticoUsd || 0), 0);
  const totalCobradoUSD = items.reduce((acc, r) => acc + (r.montoCobradoUsd || 0), 0);
  const totalCaja = totalCobradoUSD + totalDiagnosticos;

  return {
    total,
    reparados,
    entregados,
    pendientes,
    totalServicios,
    totalProductos,
    totalRepuestos,
    totalDiagnosticos,
    totalGeneral,
    totalCobradoUSD,
    totalCaja,
    estadosArr: Object.entries(estados).map(([nombre, cantidad]) => ({ nombre, cantidad }))
  };
};

// ==================== GENERAR HTML ====================

export const generarHTMLReporteRecepcion = (recepciones, titulo = 'REPORTE DE REPARACIÓN DE EQUIPOS') => {
  const empresa = getEmpresa();   // 👈 NUEVO: datos dinámicos del tenant
  const items = normalizarRecepciones(recepciones);
  const fechaActual = new Date();
  const estadisticas = calcularEstadisticasRecepcion(items);

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${titulo} - ${empresa.nombre}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: 'Arial', 'Helvetica', sans-serif;
          background: white;
          padding: 20px;
        }
        .reporte { max-width: 1400px; margin: 0 auto; }
        .header {
          padding: 15px 0;
          border-bottom: 2px solid #333;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .logo-area { display: flex; align-items: center; gap: 15px; }
        .logo-img { height: 50px; width: auto; object-fit: contain; }
        .empresa-nombre { font-size: 18px; font-weight: bold; color: #333; }
        .rif-info { text-align: right; font-size: 11px; line-height: 1.4; color: #555; }
        .titulo { padding: 10px 0; }
        .titulo h1 { font-size: 20px; font-weight: bold; color: #1a4d8c; }
        .fecha { font-size: 11px; color: #666; margin-top: 5px; }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
          border: 1px solid #ddd;
          margin-top: 20px;
        }
        th {
          background: #f5f5f5;
          padding: 8px 5px;
          text-align: left;
          font-weight: bold;
          border-bottom: 2px solid #ddd;
          color: #333;
          text-transform: uppercase;
        }
        td {
          padding: 6px 5px;
          border-bottom: 1px solid #eee;
          vertical-align: top;
        }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .badge {
          display: inline-block;
          padding: 2px 5px;
          border-radius: 3px;
          font-size: 9px;
          font-weight: bold;
          text-transform: uppercase;
        }
        .controles {
          text-align: center;
          margin-top: 20px;
          padding: 15px;
          background: #f5f5f5;
          border-radius: 8px;
        }
        button {
          padding: 8px 20px;
          cursor: pointer;
          border: 1px solid #ccc;
          background: white;
          border-radius: 5px;
        }
        @media print {
          .controles { display: none; }
          @page { margin: 1cm; size: landscape; }
        }
      </style>
    </head>
    <body>
      <div class="reporte">
        <div class="header">
          <div class="logo-area">
            ${getLogoBase64() ? `<img src="data:image/jpeg;base64,${getLogoBase64()}" class="logo-img" onerror="this.style.display='none'">` : ''}
            <div>
              <div class="empresa-nombre">${empresa.nombre}</div>
              <div class="rif-info" style="text-align: left; margin-top: 2px;">RIF: ${empresa.rif}</div>
            </div>
          </div>
          <div class="rif-info">
            ${empresa.direccion || ''}<br>
            ${empresa.ciudad}
          </div>
        </div>
        
        <div class="titulo">
          <h1>${titulo}</h1>
          <div class="fecha">Generado el: ${formatearFechaReporte(fechaActual.toISOString())}</div>
        </div>
        
        ${items.length > 0 ? `
        <table>
          <thead>
            <tr>
              <th>Orden</th>
              <th>F. Pago/Salida</th>
              <th>Cliente</th>
              <th>Equipo/Servicio</th>
              <th>Reparado Por</th>
              <th>Método</th>
              <th class="text-right">Diag. $</th>
              <th class="text-right">Serv. $</th>
              <th class="text-right">Desc. $</th>
              <th class="text-right">Total $</th>
            </tr>
          </thead>
          <tbody>
            ${items.map(item => `
              <tr>
                <td><strong>#${item.numeroOrden}</strong></td>
                <td>
                  <div style="font-weight: bold; color: #4f46e5;">${formatearFechaCorta(item.fechaPago || item.fechaEntrega || item.fechaIngreso)}</div>
                  <div style="font-size: 8px; color: #999; font-style: italic;">Ing: ${formatearFechaCorta(item.fechaIngreso)}</div>
                </td>
                <td>${item.nombreCliente}</td>
                <td>
                  <div class="font-bold">${item.descripcion}</div>
                </td>
                <td>
                  <div style="font-size: 10px; font-weight: bold;">
                    ${(() => {
                      const estado = (item.nombreEstado || '').toLowerCase();
                      const esEntregadoOReparado = estado.includes('entrega') || estado.includes('reparado');
                      return esEntregadoOReparado ? (item.nombreTecnicoReparador || item.nombreTecnico || '---') : 'PENDIENTE';
                    })()}
                  </div>
                </td>
                <td>
                  <span class="badge" style="background: ${item.metodoPago.toLowerCase().includes('cashea') ? '#f5f3ff; color: #7c3aed' : (item.metodoPago.toLowerCase().includes('empresa') ? '#eff6ff; color: #2563eb' : '#ecfdf5; color: #059669')}">
                    ${item.metodoPago}
                  </span>
                </td>
                <td class="text-right" style="color: #d97706;">${formatearMonedaUSD(item.montoPagadoDiagnosticoUsd)}</td>
                <td class="text-right" style="color: #059669;">${formatearMonedaUSD(item.montoServiciosUsd)}</td>
                <td class="text-right" style="color: #b91c1c;">${formatearMonedaUSD(item.descuento)}</td>
                <td class="text-right font-bold" style="border-left: 1px solid #eee; background: #fafafa;">${formatearMonedaUSD(item.precioTotalUsd)}</td>
              </tr>
            `).join('')}
          </tbody>
          <tfoot style="background: #f5f5f5; font-weight: bold; border-top: 2px solid #333;">
             <tr>
              <td colspan="6" class="text-right" style="padding: 10px;">TOTALES:</td>
              <td class="text-right" style="color: #d97706;">${formatearMonedaUSD(estadisticas.totalDiagnosticos)}</td>
              <td class="text-right" style="color: #059669;">${formatearMonedaUSD(estadisticas.totalServicios)}</td>
              <td class="text-right" style="color: #b91c1c;">${formatearMonedaUSD(items.reduce((sum, r) => sum + (r.descuento || 0), 0))}</td>
              <td class="text-right" style="border-left: 1px solid #ddd; font-size: 12px;">${formatearMonedaUSD(estadisticas.totalGeneral)}</td>
            </tr>
            <tr style="background: #ecfdf5; color: #047857; font-weight: bold; border-top: 1px solid #a7f3d0;">
              <td colspan="7" class="text-right" style="padding: 10px; text-transform: uppercase;">TOTAL COBRADO (CAJA):</td>
              <td class="text-right" style="padding: 10px; font-size: 14px;">${formatearMonedaUSD(estadisticas.totalCaja)}</td>
              <td colspan="2" style="font-size: 9px; font-weight: normal; font-style: italic; padding: 10px;">* Dinero real percibido (Abonos + Diag.)</td>
            </tr>
          </tfoot>
        </table>
        ` : '<div style="padding: 40px; text-align: center;">No hay registros</div>'}
        
        <div style="margin-top: 30px; font-size: 10px; text-align: center; color: #666;">
          ${empresa.nombre} - Sistema de Gestión de Taller
        </div>
      </div>
      
      <div class="controles">
        <button onclick="window.print()">🖨️ Imprimir Reporte</button>
        <button onclick="window.close()">✖️ Cerrar Ventana</button>
      </div>
    </body>
    </html>
  `;
};

// ==================== IMPRIMIR ====================

export const imprimirReporteRecepcion = async (recepciones, titulo = null) => {
  if (!recepciones || recepciones.length === 0) {
    alert('No hay registros para mostrar');
    return false;
  }

  try {
    // Resetear logo para forzar recarga del tenant actual
    LOGO_BASE64 = '';
    await cargarLogo();

    const htmlReporte = generarHTMLReporteRecepcion(recepciones, titulo);
    const ventana = window.open('', '_blank', 'width=1200,height=700,status=yes,scrollbars=yes');

    if (!ventana) {
      alert('Por favor, permite ventanas emergentes para generar el reporte');
      return false;
    }

    ventana.document.write(htmlReporte);
    ventana.document.close();
    ventana.focus();
    return true;
  } catch (error) {
    console.error('Error generando reporte:', error);
    alert('Error al generar el reporte');
    return false;
  }
};

// ==================== EXCEL ====================

export const exportarRecepcionExcel = (recepciones, titulo = 'recepcion_equipos') => {
  try {
    const items = normalizarRecepciones(recepciones);
    const XLSX = require('xlsx');
    const wb = XLSX.utils.book_new();

    const data = items.map(item => ({
      'N° Orden': item.numeroOrden,
      'Fecha Ingreso': formatearFechaCorta(item.fechaIngreso),
      'Cliente': item.nombreCliente,
      'Equipo': item.descripcion,
      'Problema': item.problema,
      'Recibido Por': item.nombreTecnicoRecepcion,
      'Reparado Por': item.nombreTecnicoReparador,
      'Monto Servicio ($)': item.montoServiciosUsd,
      'Monto Producto ($)': item.montoProductosUsd,
      'Monto Repuesto ($)': item.montoRepuestosUsd,
      'Total Orden ($)': item.precioTotalUsd,
      'Monto Cobrado ($)': item.montoCobradoUsd || 0,
      'Método Pago': item.metodoPago,
      'Referencia Pago': item.referenciaPago,
      'Estado': item.nombreEstado,
      'Actividades': item.actividadesRealizadas
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    ws['!cols'] = [
      { wch: 12 }, { wch: 15 }, { wch: 30 }, { wch: 25 },
      { wch: 40 }, { wch: 20 }, { wch: 15 }, { wch: 50 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'Recepciones');

    const fecha = new Date().toISOString().split('T')[0];
    const nombreArchivo = `${titulo}_${fecha}.xlsx`;
    XLSX.writeFile(wb, nombreArchivo);

    return { success: true, count: items.length };
  } catch (error) {
    console.error('Error exportando Excel:', error);
    return { success: false, error: error.message };
  }
};

export default {
  imprimirReporteRecepcion,
  exportarRecepcionExcel,
  generarHTMLReporteRecepcion,
  calcularEstadisticasRecepcion,
  normalizarRecepcion,
  normalizarRecepciones,
  cargarLogo,
  getLogoBase64
};